import config from 'src/globals';
import { GET_TRIP_DETAILS, GET_TRIP_DETAILS_METADATA, GET_IST_TRIP_DETAILS_METADATA, FETCH_TRIP_COMMENTS, POST_TRIP_COMMENT } from './routes';
import { GET, POST } from 'src/network/apiHandler';

export const getTripDetailsMetadata = async () => {
  const response = await GET(`${config.API_BASE_URL}${GET_TRIP_DETAILS_METADATA}`);
  return response;
};

export const getISTTripDetailsMetadata = async () => {
  return GET(`${config.API_BASE_URL}${GET_IST_TRIP_DETAILS_METADATA}`);
};

export const getTripDetails = async (params) => {
  const response = await GET(`${config.API_BASE_URL}${GET_TRIP_DETAILS}`, params);
  return response;
};

export const fetchTripComments = async (params) => {
  return GET(`${config.API_BASE_URL}${FETCH_TRIP_COMMENTS}`, params);
};

export const addTripComment = async (params) => {
  return POST(`${config.API_BASE_URL}${POST_TRIP_COMMENT}`, params);
};
